/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import { findIndex, get, isEmpty } from "lodash";
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { getCashReceiptsSalesList, deleteCashReceiptsClients } from "../../../apis/cash-receipts";
import Filters from "../../../components/Filters";
import Icon from "../../../components/Icon";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { dateToFormat, getDay } from "../../../utils/date";
import { getParams } from "../../../utils/params";
import TaxInvoiceClientMapping from "../Tax/TaxInvoiceClientMapping";
import CashInvoice from "./CashInvoice";
import CashInvoiceCreate from "./CashInvoiceIssue";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import IconButton from "../../../components/Button/IconButton";
import DeleteIcon from "../../../assets/images/icon/delete-icon-01.svg";
import systemAlert from "../../../utils/systemAlert";
import { getFinanacesScrapingHistoryList, getFinancesAccounts, scrapingFinanaces } from "../../../apis/finances/auth";
import { viewLoading } from "../../../utils/loading";

const CashInvoiceSales = ({
  open,
  setOpen,
  permission,
  scrapingPermission,
  excelDown = () => { }
}) => {
  const history = useHistory();
  const [sortFields, setSortFields] = useState([
    { key: 'tradeTime', order: 'desc' },
    { key: 'apprNo', order: '' },
    { key: 'frPartNo', order: '' },
    { key: 'trGb', order: '' },
    { key: 'supAmt', order: '' },
    { key: 'taxAmt', order: '' },
    { key: 'tip', order: '' },
    { key: 'totAmt', order: '' },
  ]);
  const [fields, setFields] = useState([]);
  const [filters] = useState([
    { title: "조회기간", key: "range.tradeTime", type: "customdatepicker" }
  ]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [formData, setFormData] = useState({});
  // 거래처 매핑
  const [isClientMappingOpen, setIsClientMappingOpen] = useState(false);
  const [clientMappingData, setClientMappingData] = useState(null);

  const [reload, setReload] = useState(false);
  const [isScraping, setIsScraping] = useState(false);
  const [timerValue, setTimerValue] = useState(0);

  const timerId = useRef(null);

  // 스크래핑
  const [financeScrapings, setFinanceScrapings] = useState([]);
  const [isScrapingReload, setIsScrapingReload] = useState(false);


  useEffect(() => {
    if (!isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      getFinancesAccounts("hometax").then(res => {
        setFinanceScrapings(get(res, 'data.accounts[0].financeScrapings', []));
      });
    }
  }, [scrapingPermission]);


  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (timerValue === 1 && !isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      setTimerValue(0);
      if (reload && !isEmpty(financeScrapings)) {
        getHistories(financeScrapings[0]);
      }
    }
  }, [timerValue]);

  const getHistories = (financeScraping) => {
    getFinanacesScrapingHistoryList(financeScraping.idx, { search: { state: 9 } })
      .then(res => {
        if (!isEmpty(res.data.histories)) {
          setReload(true);
          setIsScraping(true);
          setIsScrapingReload(true);
        } else {
          setReload(false);
          setIsScraping(false);
          isScrapingReload && reSubmit(form);
          setIsScrapingReload(false);
        }
      });
  };

  useEffect(() => {
    if (!isEmpty(financeScrapings)) {
      getHistories(financeScrapings[0]);
    }
  }, [financeScrapings]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy,
    reSubmit
  } = useForm(
    {
      range: {
        tradeTime: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date
      },
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    setFields([
      { title: "거래일자", key: "tradeTime", type: "date", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "승인번호", key: "apprNo", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "발급수단번호", key: "frPartNo", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "거래구분", key: "trGb", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "공급가액", key: "supAmt", type: 'comma', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "부가세", key: "taxAmt", type: 'comma', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "봉사료", key: "tip", type: 'comma', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "총 거래금액", key: "totAmt", type: 'comma', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      },
      {
        title: '매핑된 거래처',
        key: 'client',
        onValue: (value, field, data) => {
          return (
            !isEmpty(value) &&
            (
              <p className="pt-8 pb-8">
                <span className="vertical-middle">{value.name}</span>
                {permission.level > 1 && !data.isIssuedFromService && (
                  <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => {
                    handleRemoveClient(data, value);
                  }} />)}
              </p>
            )
          );
        }
      }
    ]);
  }, [sortFields, form]);

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  useEffect(() => {
    excelDown({ form });
  }, [form]);

  const submit = (params) => {
    setIsLoading(true);
    getCashReceiptsSalesList(getParams(params))
      .then((res) => {
        const { totalCount, list, comment } = res.data;
        const transList = list.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }));
        setList(transList);
        setTotal(totalCount);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleRowClick = (data, e) => {
    if (e.target.tagName !== "TR" && e.target.tagName !== "TD") return;
    setDetailOpen(true);
    setFormData(data);
  };

  const rowBtnConfig = {
    title: '거래처매핑',
    rowButtons: [
      {
        type: "edit",
        className: "ml-4",
        action: (data) => {
          setIsClientMappingOpen(true);
          setClientMappingData(data);
        },
      },
    ],
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };

  const handleRemoveClient = (data, value) => {
    systemAlert(`${value.name} 거래처 매핑을 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '삭제',
          onClick: () => {
            deleteCashReceiptsClients('sales', data.idx).then(() => {
              filterSubmit();
            });
          }
        }
      ]
    });
  };

  useEffect(() => {
    filterSubmit();
  }, [isClientMappingOpen]);

  const tablebuttons = [
    {
      label: "매출 현금영수증 스크래핑",
      disabled: isScraping,
      action: () => {
        systemAlert("수동 스크래핑을 진행하시겠습니까?", {
          buttons: [
            {
              label: "취소",
              color: "text"
            },
            {
              label: "확인",
              onClick: () => {
                viewLoading(true);
                scrapingFinanaces(financeScrapings[0].idx, {
                  svcCd: "Z4001",
                  sdate: dateToFormat(new Date(), "YYYYMMDD"),
                  edate: dateToFormat(new Date(), "YYYYMMDD")
                })
                  .then(() => {
                    setReload(true);
                    setIsScraping(true);
                    systemAlert(
                      <>
                        <p>스크래핑 요청에 성공하였습니다.</p>
                        <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                        <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                        <p> 관리자 -&gt; 금융정보 자동 수집 -&gt; 수집이력에서</p>
                        <p>스크래핑 결과를 확인하실 수 있습니다.</p>
                      </>
                      , {
                        buttons: [
                          {
                            label: "수집이력 확인하기",
                            onClick: () => {
                              history.push("/manager/financial?tab=scraping-history");
                            }
                          },
                          {
                            label: "확인",
                            onClick: () => {
                              getHistories(financeScrapings[0]);
                            }
                          },
                        ]
                      });
                  })
                  .catch(() => { })
                  .finally(() => {
                    viewLoading(false);
                  });
              }
            }
          ]
        });
      },
      isHide: isEmpty(financeScrapings) || isEmpty(scrapingPermission) || 1 >= scrapingPermission.level,
    },
  ];

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        isControl
        buttons={tablebuttons}
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        onSelect={handleRowClick}
        selectedList={selectedList}
        setSelected={setSelectedList}
        submit={handleSubmit}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
      />
      {detailOpen && (
        <CashInvoice
          open={detailOpen}
          setOpen={setDetailOpen}
          data={formData}
          setData={setFormData}
          invoiceType={"sales"}
          submit={filterSubmit}
          permission={permission}
        />
      )}
      {open && (
        <CashInvoiceCreate
          open={open}
          setOpen={setOpen}
        />
      )}
      {isClientMappingOpen && (
        <TaxInvoiceClientMapping
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          data={clientMappingData}
          setData={setClientMappingData}
          submit={filterSubmit}
          invoiceType="cash-invoice"
          type="sales"
        />
      )}
    </>
  );
};

export default CashInvoiceSales;
